module.exports = __webpack_public_path__ + "img/ph_manange3.be61d203.png";